<template>
  <div class="home container">
    <div class="columns">
      <spinner v-if="$store.state.isLoading"></spinner>
      <div class="column">
        <h2>ניהול סדרות ותוכניות אימונים</h2>
      </div>
    </div>
    <div class="box nav-box">
      <strong>הצג:</strong>
      <button :class="isActive(1)" @click="editing = 1">תוכניות אימונים</button>
      <button :class="isActive(2)" @click="editing = 2">סדרות</button>
    </div>
    <div class="content-scroll series-list">
      <zoom-x-transition :group="true" tag="div">
        <series-item
          v-for="item in show"
          :key="item.id"
          :item="item"
        ></series-item>
      </zoom-x-transition>
    </div>
  </div>
</template>

<script>
import SeriesItem from "@/components/seriesItem.vue";
import Spinner from "@/components/spinner.vue";
import { ZoomXTransition } from "vue2-transitions";

export default {
  components: {
    SeriesItem,
    Spinner,
    ZoomXTransition
  },
  data() {
    return {
      editing: 1
    };
  },
  watch: {
    series() {
      if (this.series.length > 0) {
        this.$store.commit("setLoadStatus", false);
      }
    }
  },
  computed: {
    series() {
      return this.$store.state.seriesData.filter(
        item => parseInt(item.parent, 10) === 10
      );
    },
    collections() {
      return this.$store.state.seriesData.filter(
        item => parseInt(item.parent, 10) !== 10
      );
    },
    show() {
      if (this.editing === 1) {
        return this.series;
      }
      return this.collections;
    }
  },
  methods: {
    isActive(num) {
      if (num === this.editing) {
        return "button is-success";
      }
      return "button";
    }
  },
  mounted() {
    if (
      this.$store.state.data.teachers &&
      this.$store.state.seriesData.length > 0 &&
      this.$store.state.videos.length > 0
    ) {
      this.loaded = true;
    } else {
      this.$store.commit("setLoadStatus", true);
    }
  }
};
</script>

<style lang="scss">
body {
  background-color: #f2f2f2;
}
.home {
  direction: rtl;
  text-align: right;
  h2 {
    text-align: right;
    font-size: 24px;
    margin: 10px 0 0;
  }
  .box {
    background-color: hsl(0, 0%, 86%);
  }
}

.nav-box {
  .button {
    margin-right: 0.5rem;
  }
}

.content-scroll {
  max-height: 75vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.series-list > div {
  display: flex;
  flex-wrap: wrap;
}
</style>
